export enum IZendeskTicketType {
  Problem = 'problem',
  Incident = 'incident',
  Question = 'question',
  Task = 'task',
}

export enum IZendeskTicketPriority {
  Low = 'low',
  Normal = 'normal',
  High = 'high',
  Urgent = 'urgent',
}

interface ZendeskUser {
  user_email: string;
  user_name?: string;
}

export interface ZendeskTicket {
  subject: string;
  comment: {
    uploads?: string[];
    body?: string; // least sanitized (defaults to plain_body if an error in sanitizing)
    plain_body?: string; // most sanitized
    html_body?: string;
  };
  assignee_email?: string;
  followers: ZendeskUser[];
  custom_fields: {
    id: number;
    value: string;
  }[];
  type: IZendeskTicketType;
  priority?: IZendeskTicketPriority;
  tags: string[];
  group_id?: number;
  requester?: {
    locale_id?: number;
    name: string;
    email: string;
  };
  email_ccs?: ZendeskUser[];
}
